export default __webpack_public_path__ + "static/media/Alta de Prestación en Convenio.d309bd35.xlsx";